import React from 'react';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import styles from './region-entity-table.module.scss';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
  setActiveEntity,
  setComparedEntity,
  setActivePage,
} from '../../actions/ui';
import { groupByKey } from '../../helpers/group-by-key';

const EntitiesLinks = ({
  setActiveEntity,
  setComparedEntity,
  setActivePage,
  entities,
}) => {
  const groupedEntities = groupByKey(entities, 'listCategory');
  const groupedEntityLists = Object.entries(groupedEntities);

  return (
    <div style={{ width: '100%', padding: 20, marginTop: 40 }}>
      <div style={{ marginBottom: 30 }}>
        <span className={styles.tableHeaderText}>
          Explore All Transport Entities
        </span>
      </div>
      <div className={styles.groupedEntityLists}>
        {groupedEntityLists.map(([key, entities]) => {
          return (
            <div className={styles.groupedEntityList}>
              <div
                className={`${styles.dataCaption} ${styles.dataSuperscript}`}
              >
                {entityLabelMatcher(key, 'plural')}
              </div>
              {entities.map((e) => {
                return (
                  <div
                    key={e.id}
                    className={`${styles.gridValueText} ${styles.entityLinkText}`}
                    onClick={() => {
                      setActiveEntity(e.id);
                      setComparedEntity(null);
                      setActivePage('entity');
                    }}
                  >
                    {e.name}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveEntity,
  setComparedEntity,
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
  entities: selectors.getEntities(state),
});

EntitiesLinks.propTypes = {
  region: PropTypes.object,
  setActiveEntity: PropTypes.func,
  setActivePage: PropTypes.func,
  setComparedEntity: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesLinks);



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entities-links.js